import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import { _delete, get, postWithHeaders, postWithHeadersResponse, put, putWithHeadersResponse } from "../../../server/actions";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import { required, email, zipValidation, isNumeric, phoneNo } from '../../../server/validationMethods'
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { _addNotification, _addNotificationError, numberOnly } from "../../../server/util";


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
const caterings = {
    "firstName": "",
    "lastName": "",
    "mobileNo": "",
    "role": "ROLE_CATERER",
    "isActive": true,
    "username": "",
    "isPrimaryUser": true,
    //"nutritionAnalysis":this.state.isUpdate
}

class CatererRecord extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            catererId: 0,
            countryListDetails: [],
            countryData: [],
            timeZones: [],
            isdCode: '',
            isActiveNutrition: false,
            inventoryEnabled: false,
            catererDetails: {
                "name": "",
                "addressLine1": "",
                "addressLine2": "",
                "city": "",
                "country": "",
                "state": "",
                "zip": "",
                timezone: '',
                faxNumber: '',
                contactNumber: '',
                catererUsers: [JSON.parse(JSON.stringify(caterings))]
            }
        }
        this.getCatererDetails = this.getCatererDetails.bind(this);
        this.saveCatererDetails = this.saveCatererDetails.bind(this)
        console.log('CatererDetails::::', this.state.catererDetails);
    }

    componentWillMount = () => {
        const { cid } = this.context.router.route.match.params;
        let _catererId = 0;
        try {
            if (parseInt(cid) > 0) {
                _catererId = parseInt(cid)
            }
        } catch (ex) {
        }
        this.setState({ catererId: _catererId }, () => {
            // if(this.state.catererId>0){
            this.getCountryList();
            //}            
        });
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getCountryList() {
        this.setState({ loading: true });
        get('/countryDetails?&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let countryList = [];
            data._embedded.countryDetails.forEach(function (val) {
                countryList.push({ text: val.countryCode + ' (' + val.countryName + ')', value: val.countryCode });
            });
            this.setState({ loading: false, countryListDetails: countryList, countryData: data._embedded.countryDetails },
                this.getCatererDetails(this.state.catererId));
        })
            .catch(
                (error) => {
                    this.setState({ loading: false });
                    console.log('Onboard School response', error)
                }
            )
    }
    getCatererDetails = (id) => {
        this.setState({ loading: true });
        get('/caterers/' + id + '?&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let tzList = [];
            let isdCode = '';
            //nutritionAnalysis=this.state.nutritionAnalysis;
            this.state.countryData.filter(item => {
                if (item.countryCode === data.country) {
                    isdCode = item.isdCode;
                    JSON.parse(item.timezoneInfo).forEach(function (val) {
                        tzList.push({ text: val.timezoneName + ' (' + val.timezoneDesc + ')', value: val.timezoneName });
                    })
                }
            });
            data.caterers = (data.caterers || []).length > 0 ? data.caterers : [JSON.parse(JSON.stringify(caterings))]
            this.setState({ loading: false, catererDetails: data, timeZones: tzList, isdCode: isdCode, isActiveNutrition: data.nutritionAnalysis, inventoryEnabled: data.inventoryEnabled });
        })

            .catch(
                (error) => {
                    this.setState({ loading: false });
                    console.log('Onboard School response', error)
                }
            )
    }

    saveCatererDetails = (e) => {
        e.preventDefault();
        let _caterer = JSON.parse(JSON.stringify(this.state.catererDetails));
        this.setState({ loading: true });
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        _caterer.id = this.state.catererId;
        _caterer.nutritionAnalysis = this.state.isActiveNutrition;
        _caterer.inventoryEnabled = this.state.inventoryEnabled;
        console.log("Caterer::::::", JSON.stringify(_caterer));
        if (this.state.catererId > 0) {
            putWithHeadersResponse(`/${this.state.catererId}/caterer?access_token=`, JSON.stringify(_caterer), headers)
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then((data) => {
                    _addNotification('Successfully updated caterer data.', this);
                    this.setState({ loading: false });
                    setTimeout(() => {
                        this.context.router.history.push('/superAdmin/catererList')
                    }, 3000);
                    console.log('Access Links Sent', data);
                }).catch(error => {
                    this.setState({ loading: false });
                    //document.getElementById("submit").disabled = false;
                    _addNotificationError('Could not updated caterer data.', this);
                    console.log('update caterer response', error)

                });
        } else {
            postWithHeaders('/caterers/?access_token=', JSON.stringify(_caterer), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();

            }).then((data) => {
                _addNotification('New Caterer Onboard Successfully.', this);
                this.setState({ loading: false });
                setTimeout(() => {
                    this.context.router.history.push('/superAdmin/catererList')
                }, 3000);
            }).catch(error => {
                this.setState({ loading: false });
                //document.getElementById("submit").disabled = false;
                _addNotificationError('Failed to onboard new Caterer.', this);
                console.log('Add Caterer response', error);

            });
        }
    }
    selectCountry = (e) => {
        let tzList = [];
        let isdCode = '';
        this.state.countryData.filter(item => {
            if (item.countryCode === e.target.value) {
                isdCode = item.isdCode;
                JSON.parse(item.timezoneInfo).forEach(function (val) {
                    tzList.push({ text: val.timezoneName + ' (' + val.timezoneDesc + ')', value: val.timezoneName });
                })
            }
        });
        let data = this.state.catererDetails;
        data.country = e.target.value;
        data.countryCode = e.target.value;
        data.timeZone = '';
        this.setState({ catererDetails: data, timeZones: tzList, isdCode: isdCode });
    }
    selectTimeZone = (e) => {
        let data = this.state.catererDetails;
        data.timezone = e.target.value;
        this.setState({ catererDetails: data });
    }
    handleCheckBoxChange = (e) => {
        const isActiveNutrition = this.state.isActiveNutrition;
        this.setState({ isActiveNutrition: !isActiveNutrition });
    }
    handleInvEnableCheckBoxChange = (e) => {
        const inventoryEnabled = this.state.inventoryEnabled;
        this.setState({ inventoryEnabled: !inventoryEnabled });
    }

    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="sectionTitle">
                        <h2>
                            <span>{this.state.catererId > 0 ? 'Update Caterer' : 'Onboard - New Caterer'}</span>
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 col-xs-12">
                            <div className="panel panel-info">
                                <div className="panel-heading text-center">
                                    <h3 className="panel-title"><i
                                        className="" /> CATERER
                                    </h3>
                                </div>

                                <div className="panel-body panel-body-onboard">
                                    <Form ref={c => { this.form = c }} onSubmit={this.saveCatererDetails}>
                                        <div>
                                            <div className="form-group"
                                                id="catererName">
                                                <label className="control-label" htmlFor="catererName">Caterer Name*</label>
                                                <Input name="name" className="form-control border-color-1 rounded"
                                                    value={this.state.catererDetails.name}
                                                    validations={[required]} requiredmsg={'Please enter caterer name'}
                                                    onChange={(e) => {
                                                        let caterer = this.state.catererDetails;
                                                        caterer['name'] = e.target.value;
                                                        this.setState({ catererDetails: caterer });
                                                    }} />
                                            </div>
                                            <div className="form-group"
                                                id="addressLine1">
                                                <label className="control-label" htmlFor="addressLine1">Address*</label>
                                                <Input name="addressLine1"
                                                    className="form-control border-color-1 rounded"
                                                    value={this.state.catererDetails.addressLine1}
                                                    validations={[required]} requiredmsg={'Please enter caterer address'}
                                                    onChange={(e) => {
                                                        let caterer = this.state.catererDetails;
                                                        caterer['addressLine1'] = e.target.value;
                                                        this.setState({ catererDetails: caterer });
                                                    }} />
                                            </div>
                                            <div className="form-group"
                                                id="city">
                                                <label className="control-label" htmlFor="city">City(District)*</label>
                                                <Input name="city"
                                                    className="form-control border-color-1 rounded" validations={[required]} requiredmsg={'Please enter city'}
                                                    value={this.state.catererDetails.city} onChange={(e) => {
                                                        let caterer = this.state.catererDetails;
                                                        caterer['city'] = e.target.value;
                                                        this.setState({ catererDetails: caterer });
                                                    }} />
                                            </div>
                                            <div className="form-group"
                                                id="state">
                                                <label className="control-label" htmlFor="state">State*</label>
                                                <Input name="state"
                                                    className="form-control border-color-1 rounded"
                                                    value={this.state.catererDetails.state}
                                                    validations={[required]} requiredmsg={'Please enter state'}
                                                    onChange={(e) => {
                                                        let caterer = this.state.catererDetails;
                                                        caterer['state'] = e.target.value;
                                                        this.setState({ catererDetails: caterer });
                                                    }} />
                                            </div>
                                            <div className="form-group"
                                                id="catererZip">
                                                <label className="control-label" htmlFor="zip">Zip*</label>
                                                <Input name="zip" validations={[required, zipValidation]} requiredmsg={'Please enter zip code'}
                                                    className="form-control border-color-1 rounded"
                                                    value={this.state.catererDetails.zip}
                                                    onChange={(e) => {
                                                        let caterer = this.state.catererDetails;
                                                        caterer['zip'] = e.target.value;
                                                        this.setState({ catererDetails: caterer });
                                                    }} />
                                            </div>
                                            <div className="form-group" id="country">
                                                <label className="control-label" htmlFor="country">Country ISO Code*</label>
                                                <Input list="countrylist" name="country" id="country" validations={[required]} requiredmsg={'Please select country code'}
                                                    onChange={e => this.selectCountry(e)}
                                                    value={this.state.catererDetails.country}
                                                    className="form-control border-color-1 rounded"
                                                    placeholder="Search..." autoComplete="off"
                                                />
                                                <datalist id="countrylist">
                                                    {this.state.countryListDetails.map((country, key) =>
                                                        <option data-id={key}
                                                            value={country.value}>{country.text}</option>
                                                    )}
                                                </datalist>
                                            </div>
                                            <div className="form-group" id="timezone">
                                                <label className="control-label" htmlFor="country">Time zone*</label>
                                                <Input list="timeZonelist" name="timezone" id="timezone"
                                                    validations={[required]} requiredmsg={'Please select time zone'}
                                                    onChange={e => this.selectTimeZone(e)}
                                                    value={this.state.catererDetails.timezone}
                                                    className="form-control border-color-1 rounded"
                                                    placeholder="Search..." autoComplete="off"
                                                    disabled={this.state.timeZones.length > 0 ? false : true} />
                                                <datalist id="timeZonelist">
                                                    {this.state.timeZones.map((zone, key) =>
                                                        <option data-id={key}
                                                            value={zone.value}>{zone.text}</option>
                                                    )}
                                                </datalist>
                                            </div>
                                            <div className="form-group">
                                                <label className="control-label" htmlFor="country">Fax</label>
                                                <div className="input-group">
                                                    <span className="input-group-addon">{this.state.isdCode}</span>
                                                    <Input type="text" style={{ zIndex: '1' }}
                                                        name="faxNumber"
                                                        className="form-control"
                                                        value={(this.state.catererDetails.faxNumber || '').slice(-10)}
                                                        id="faxNumber"
                                                        validations={[isNumeric, phoneNo]}
                                                        placeholder={'Fax Number'}
                                                        onChange={e => {
                                                            let caterer = this.state.catererDetails;
                                                            caterer['faxNumber'] = e.target.value;
                                                            this.setState({ catererDetails: caterer });
                                                        }}
                                                        maxLength={10}
                                                        onKeyPress={numberOnly} />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="control-label" htmlFor="contactNumber">Phone*</label>
                                                <div className="input-group">
                                                    <span className="input-group-addon">{this.state.isdCode}</span>
                                                    <Input type="text" style={{ zIndex: '1' }}
                                                        name="contactNumber"
                                                        className="form-control"
                                                        value={(this.state.catererDetails.contactNumber || '').slice(-10)}
                                                        id="contactNumber"
                                                        validations={[required, isNumeric, phoneNo]} requiredmsg={'Please enter phone no'}
                                                        placeholder={'Mobile Number'}
                                                        onChange={e => {
                                                            let caterer = this.state.catererDetails;
                                                            caterer['contactNumber'] = e.target.value;
                                                            this.setState({ catererDetails: caterer });
                                                        }}
                                                        maxLength={10}
                                                        onKeyPress={numberOnly} />
                                                </div>
                                            </div>


                                            <div className="checkbox col-sm-12" style={{ marginTop: '10px', padding: '0' }}>
                                                <label>
                                                    <input type="checkbox"  checked={this.state.isActiveNutrition} name="isActiveNutrition" onChange={(e) => { this.handleCheckBoxChange(e) }} />
                                                    <b>Activated Nutrition Analysis</b></label>
                                            </div>
                                            <div className="checkbox col-sm-12" style={{ marginTop: '10px', padding: '0' }}>
                                                <label>
                                                    <input type="checkbox" checked={this.state.inventoryEnabled} name="inventoryEnabled" onChange={(e) => { this.handleInvEnableCheckBoxChange(e) }} />
                                                    <b>Inventory Enabled</b></label>
                                            </div>

                                            <div className="form-group col-sm-12">
                                                <h2 style={{
                                                    width: '100%',
                                                    textAlign: 'center',
                                                    borderBottom: '1px solid #000',
                                                    lineHeight: '0.1em',
                                                    margin: '10px 0 20px',
                                                    color: 'gray'
                                                }}>
                                                    <span style={{ background: '#fff', padding: '0 10px' }}
                                                        className="panel-title">Admin</span></h2>
                                            </div>
                                            {this.state.catererDetails.catererUsers.map((user, idx) => {
                                                if (user.isPrimaryUser)
                                                    return (<div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="country">First
                                                                Name*</label>
                                                            <Input type="text" name="firstName"
                                                                className="form-control border-color-1 rounded" id="fname"
                                                                placeholder="First Name" value={user.firstName}
                                                                validations={[required]} requiredmsg={'Please enter first name'}
                                                                onChange={(e) => {
                                                                    let _catererDetails = this.state.catererDetails;
                                                                    let _users = _catererDetails.catererUsers;
                                                                    _users[idx]['firstName'] = e.target.value
                                                                    _catererDetails.catererUsers = _users;
                                                                    this.setState({ catererDetails: _catererDetails });
                                                                }} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="district">Last
                                                                Name*</label>
                                                            <Input type="text" name="lastName"
                                                                className="form-control border-color-1 rounded" id="lastName"
                                                                placeholder="Last Name" value={user.lastName}
                                                                validations={[required]} requiredmsg={'Please enter last name'}
                                                                onChange={(e) => {
                                                                    let _catererDetails = this.state.catererDetails;
                                                                    let _users = _catererDetails.catererUsers;
                                                                    _users[idx]['lastName'] = e.target.value
                                                                    _catererDetails.catererUsers = _users;
                                                                    this.setState({ catererDetails: _catererDetails });
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="country">Phone*</label>
                                                            <div className="input-group">
                                                                <span className="input-group-addon">{this.state.isdCode}</span>
                                                                <Input type="text" style={{ zIndex: '1' }}
                                                                    className="form-control"
                                                                    value={((user || {}).mobileNo || '').slice(-10)}
                                                                    id="mobileNo"
                                                                    validations={[required, isNumeric, phoneNo]} requiredmsg={'Please enter phone no'}
                                                                    placeholder={'Mobile Number'}
                                                                    onChange={(e) => {
                                                                        let _catererDetails = this.state.catererDetails;
                                                                        let _users = _catererDetails.catererUsers;
                                                                        _users[idx]['mobileNo'] = e.target.value
                                                                        _catererDetails.catererUsers = _users;
                                                                        this.setState({ catererDetails: _catererDetails });
                                                                    }}
                                                                    maxLength={10}
                                                                    onKeyPress={numberOnly} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="username">Email ID*</label>
                                                            <Input type="email" name={'username'} id="username"
                                                                pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                                className="form-control border-color-1 rounded"
                                                                validations={[required, email]} requiredmsg={'Please enter email id'}
                                                                placeholder="Email ID" value={user.username}
                                                                onChange={(e) => {
                                                                    let _catererDetails = this.state.catererDetails;
                                                                    let _users = _catererDetails.catererUsers;
                                                                    _users[idx]['username'] = e.target.value
                                                                    _catererDetails.catererUsers = _users;
                                                                    this.setState({ catererDetails: _catererDetails });
                                                                }}
                                                            />
                                                            <span id={user.username} className="validateMessage"></span>
                                                        </div>
                                                        <div className="checkbox col-sm-12" style={{ marginTop: '10px', padding: '0' }}>
                                                            <label style={{ fontWeight: '700' }}>
                                                                <input type="checkbox" className="radio" checked={user.isActive}
                                                                    name="isActive" onChange={(e) => {
                                                                        let _catererDetails = this.state.catererDetails;
                                                                        let _users = _catererDetails.catererUsers;
                                                                        _users[idx]['isActive'] = e.target.checked ? true : false
                                                                        _catererDetails.catererUsers = _users;
                                                                        this.setState({ catererDetails: _catererDetails });
                                                                    }} />Is Active </label>
                                                        </div>
                                                    </div>)
                                            })}


                                            <div className="col-md-12 col-sm-12 col-xs-12">

                                                <button className="pull-left btn btn-primary btn-sm" type="button" onClick={() => {
                                                    this.context.router.history.push('/SuperAdmin/catererList')
                                                }}
                                                    style={{ margin: 0, fontSize: 14 }}>Back
                                                </button>

                                                <Button className="btn btn-success btn-sm pull-right"
                                                    type="Submit" style={{ margin: 0, fontSize: 14 }}
                                                >Finish
                                                </Button>
                                            </div>

                                        </div>
                                    </Form>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
CatererRecord.contextTypes = {
    router: PropTypes.object.isRequired
}

export default CatererRecord;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/caterer/catererRecord.jsx